<template>
<v-container>
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
     <v-dialog v-model="infoDialog" max-width="600px" persistent>
         <v-card>
              <v-card-title class="font-weight-bold">温馨提示</v-card-title>
              <v-card-text class="text-xs-h5 mt-2" style="text-align: left;" v-html="infoMsg">
                {{infoMsg}}
           <!--     <v-btn v-show="showButton" @click="goToRB()">我的预约</v-btn> -->
              </v-card-text>
              <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="green darken-1"
                text
                @click="infoDialog = false;"
              >
                确定
              </v-btn>
              </v-card-actions>
         </v-card>
    </v-dialog>
    <bookingForm :formStyle="formStyle"></bookingForm>
    <v-data-iterator
      locale="zh-Hans"
      :items="items"
    >
      <template v-slot:header>
        <v-toolbar
          class="mb-2"
          color="grey lighten-4"
          flat
          outlined
        >
          <v-toolbar-title> <v-icon style="font-size:30px"> {{currentTemplate.Icon}} </v-icon>  {{currentTemplate.Name}} {{subtitle}}</v-toolbar-title>
        </v-toolbar>
      </template>

      <template v-slot:default="props">
        <v-row>
          <v-col
            v-for="item in props.items"
            :key="item.name"
            cols="12"
            sm="6"
            md="6"
            lg="4"
          >
            <v-card>
              <v-card-title class="subheading font-weight-bold">{{ convertDate(item.date) }}</v-card-title>

              <v-divider></v-divider>

              <v-list dense>
                <v-list-item v-for="slot in item.slots" :key="slot.identity">
                  <v-list-item-content>{{convertTime(slot.EventSlot.StartTime)}} - {{convertTime(slot.EventSlot.EndTime)}}</v-list-item-content>
                  <v-list-item-content>剩余空位: {{ slot.AvailableCapacity }}</v-list-item-content>
                  <v-list-item-content>   
                    <v-btn 
                    v-show="slot.AvailableCapacity > 0" 
                    class="mb-2" 
                    color="green" 
                    outlined 
                    :disabled="!isFuture(item.date, slot.EventSlot.StartTime)"
                    @click="book(slot)">
                    <v-icon v-show="currentTemplate.IconAvailable">{{currentTemplate.IconAvailable}}</v-icon>
                    预定
                    </v-btn>
                    <v-btn 
                    v-show="slot.AvailableCapacity <= 0" 
                    class="mb-2" 
                    color="red" 
                    outlined 
                    :disabled="!isFuture(item.date, slot.EventSlot.StartTime)"
                    >
                     <v-icon v-show="currentTemplate.IconFull">{{currentTemplate.IconFull}}</v-icon>
                      已满
                      </v-btn>
                     
                  </v-list-item-content>
                </v-list-item>

               
              </v-list>
       
            </v-card>
          </v-col>
        </v-row>
      </template>
      
    </v-data-iterator>
    
    </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import moment from 'moment';
import {EventBus} from '@/plugins/event-bus';
import bookingForm from '@/components/BookingForm/BookingForm.vue';

export default {
    name: 'eventBooking',
    components: {bookingForm},
    data: () => ({
      items: [],
      slots: [],
      currentTemplate: '',
      subtitle: '',
      templateId: '',
      formStyle: { type:"SINGLE", approvalRequired: false, size:1},
      isLoading: false,
      bookingType: {},
      infoDialog: false,
      infoMsg: ''
    }),
    computed: {
      ...mapGetters(["eventSlot" , "eventTemplate", "formStyles", "bookingTypes", "userProfile"])
    },
    methods: {
     isFuture(date, utcTime, grace = -15)
     {
       if (this.formStyle.Name=='游泳馆预约') grace = -120;

       var localDateTime = moment(date).format('YYYY-MM-DD')+"T"+moment(utcTime).format("HH:mm");
       return moment().add('minutes', grace).isBefore(moment(localDateTime));
     },
     convertTime(utcTime)
     {
        var localTime = moment(utcTime).format("HH:mm"); 
        return localTime;
     },
     convertDate(date)
     {
       moment.locale('zh-cn');
       return moment(date).format('YYYY-MM-DD dddd');
     },
     book(slot)
     {
       

        let result = this.userProfile.UserGroups.filter((v)=>{
          return this.currentTemplate.ManagePermission.findIndex(x=>x.Identity===v.Identity)!==-1;
        });

        if (result.length>0) slot.isAdmin = true;
        else slot.isAdmin = false;

        EventBus.$emit('openModal', slot);
     },
     async initialize(isSaved)
     {    
        this.isLoading = true;
        try
        {
              if (!this.$route.params.id) this.$router.push('/');
              this.templateId = this.$route.params.id;
             //  if (this.templateId == '17c98bde-0b85-420b-b3b4-1615cd6d6f81') this.formStyle = {type: "GROUP", approvalRequired: true, size: 20};
             //  else
             //    this.formStyle = { type:"SINGLE", approvalRequired: false, size:1};

              await this.$store.dispatch('getEventSlot', { id:this.templateId, from: moment().format('YYYY-MM-DD'), to: moment().add('days', 6).format('YYYY-MM-DD')}) ;
              this.items = [];
              this.slots = [];
              await this.$store.dispatch('getEventTemplate',  this.templateId);
              this.currentTemplate = this.eventTemplate(this.templateId);

              if (!isSaved)
              {
                  if (!this.bookingTypes || this.bookingTypes.length === 0)
                      await this.$store.dispatch('getBookingType');
                  this.bookingType = this.bookingTypes.find(x=>x.Identity ==  this.currentTemplate.BookingTypeIdentity);
                  if (this.bookingType.InfoEnabled)
                  {
                    this.infoDialog = true;
                    this.infoMsg = this.bookingType.InfoMessage;
                  }
              }
              
              if (!this.formStyles(this.currentTemplate.FormStyleIdentity))
                await this.$store.dispatch('getFormStyle');
              if (!this.userProfile)
                await this.$store.dispatch('getUserProfile');
              
              this.formStyle = this.formStyles(this.currentTemplate.FormStyleIdentity);
           
              this.isLoading = false;
              if (this.eventSlot(this.templateId))
              {
                let allSlots = [];
                let slotsByDate = this.eventSlot(this.templateId);
                for (var i=0; i < slotsByDate.length; i++)
                {
                  if (this.items.findIndex(x=>x.date==slotsByDate[i].Date)==-1)
                  {
                    this.items.push({'date': slotsByDate[i].Date});
                  }
                  allSlots.push(slotsByDate[i]);
                }
                for (var i=0; i < this.items.length; i++)
                {
                  this.items[i].slots = allSlots.filter(x=>x.Date == this.items[i].date);
                }
              }
         }
        catch (e)
        {
            console.log(e);
            this.$router.push('/');
        }
      }
    },
    async mounted (){ 
      EventBus.$on('saved',()=>{
        //console.log('saved');
        this.initialize(true);
      });
      
      this.initialize(false);
     
    },
    watch:{
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/BookingType/eventBooking.vue